export default __webpack_public_path__ + "static/media/MQ-welcome.231579a6.png";